import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import axios from 'axios';
import { Clinic } from '../../models/MedVox/Clinic';
import { Status } from '../../models/common/Status';
import { RootState } from '../store';
import { apiClientWithApi } from '../../utils/http';

export interface ClinicState {
  clinics: Clinic[];
  status: Status;
}

const initialState: ClinicState = {
  clinics: [],
  status: {
    responseLoading: true,
    responseError: null,
    requestSuccess: null,
    requestError: null,
  },
};

export const getClinics = createAsyncThunk(
  'clinic/getClinics',
  async (_, { rejectWithValue }) => {
    try {
      const response = await apiClientWithApi.get<Clinic[]>('clinic');
      return response.data;
    } catch (error) {
      if (axios.isAxiosError(error)) {
        return rejectWithValue(error.message);
      } else return rejectWithValue('Не удалось получить список клиник!');
    }
  },
);

export const clinicSlice = createSlice({
  name: 'clinic',
  initialState,
  reducers: {},
  extraReducers(builder) {
    builder
      .addCase(getClinics.pending, (state) => {
        state.status.responseLoading = true;
        state.status.responseError = null;
        return state;
      })
      .addCase(getClinics.fulfilled, (state, action) => {
        state.status.responseLoading = false;
        state.status.responseError = null;
        state.clinics = action.payload;
        return state;
      })
      .addCase(getClinics.rejected, (state) => {
        state.status.responseLoading = false;
        state.status.responseError = 'Не удалось получить список клиник';
      });
  },
});

export default clinicSlice.reducer;

export const selectClinics = (state: RootState) => state.clinic.clinics;
export const clinicsStatus = (state: RootState) => state.clinic.status;
